import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import NavBar from '../../components/NavBar';
import styled from 'styled-components';
import landing_photo from 'src/assets/LandingPage/landing_photo.png';
import match from 'src/assets/LandingPage/match.svg';
import info from 'src/assets/LandingPage/info.svg';
import store from 'src/assets/LandingPage/store.svg';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import CenteredPageContainer from '../../components/CenteredPageContainer';
import RectangleButton from '../../components/Buttons/RectangleButton';
import StepItem from './components/StepItem';
import PricingCard from './components/PricingCard';
import QuoteItem from './components/QuoteItem';
import Karim_profile from 'src/assets/PersonalImages/Karim_profile.png';
import Alexa_profile from 'src/assets/PersonalImages/Alexa_profile.png';
import Skim_profile from 'src/assets/PersonalImages/Skim_profile.png';
import * as queryString from 'query-string';

const LandingHeader = styled.h1`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 52px;
  color: #00144d;
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const LandingText = styled.p`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 16px;
  line-height: 23px;
  margin-top: 24px;
  color: rgba(0, 20, 77, 0.6);
  max-width: 350px;
`;

const LandingPageContainer = styled(Container)`
  margin-top: 16vh;
  @media (max-width: 768px) {
    margin-top: 4vh;
  }
`;

const LandingPageImage = styled.img`
  @media (max-width: 768px) {
    margin-top: 32px;
  }
`;

const PricingTitle = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 34px;
  text-align: center;

  color: #ffffff;
  margin-bottom: 4px;
`;

const PricingSaveText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 34px;
  text-align: center;

  color: #fafafa;
  margin-bottom: 0px !important;

  span {
    font-weight: 600;
  }
`;

const TestimonialTitle = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 34px;
  text-align: center;

  color: #333333;
  margin-bottom: 4px;
`;

const TestimonialDetail = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  color: #828282;

  margin-bottom: 32px;
`;

const PricingDetail = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  color: #fafafa;

  margin-bottom: 32px;
`;

class LandingPage extends React.Component<RouteComponentProps<any>, any> {
  render() {
    const params = queryString.parse(document.location.search);
    const redirect = params.redirect; // this would be "abcdefg" if the query was "?redirect=abcdefg"
    if (document.location.pathname === '/' && redirect) {
      this.props.history.push(`${redirect}`);
      // document.location.assign(`${document.location.origin}${redirect}`);
    }

    return (
      <CenteredPageContainer>
        <NavBar />
        <LandingPageContainer fluid>
          <Row style={{ paddingLeft: 45 }}>
            <Col xs={{ size: 12 }} lg={{ size: 5 }} style={{ paddingLeft: 0 }}>
              <LandingHeader>Reliable storage at an unbeatable price.</LandingHeader>
              <LandingText>
                Get connected with students living off-campus for the cheapest, highest quality
                storage available at Penn.
              </LandingText>
              <RectangleButton
                style={{ marginTop: 44, width: 148 }}
                onClick={() => this.props.history.push('/getting-started')}
              >
                Get Started
              </RectangleButton>
            </Col>
            <Col xs={{ size: 12 }} lg={{ size: 7 }}>
              <LandingPageImage src={landing_photo} className="img-fluid" alt="landing-image" />
            </Col>
          </Row>

          <Row
            style={{
              backgroundColor: '#f2f2f2',
              paddingTop: 108,
              paddingBottom: 100,
              paddingLeft: 45,
              paddingRight: 45,
            }}
          >
            <Col xs={{ size: 12 }} md={{ size: 4 }} style={{ textAlign: 'center' }}>
              <StepItem
                image={info}
                title="1. Tell us what you want to store"
                detail="Let us know what you’re storing, so we can match you with the best home possible for
                your items. We’ve manually vetted hosts for quality assurance."
              />
            </Col>
            <Col xs={{ size: 12 }} md={{ size: 4 }} style={{ textAlign: 'center' }}>
              <StepItem
                image={match}
                title="2. Get matched with a host"
                detail="We’ll find you the best possible host. Regardless of who you’re storing with, all
                prices are the same and will always be the lowest on campus."
              />
            </Col>
            <Col xs={{ size: 12 }} md={{ size: 4 }} style={{ textAlign: 'center' }}>
              <StepItem
                image={store}
                title="3. Store with our vetted hosts"
                detail="You’ll drop-off and pick up your items at your host’s off-campus housing for your
                chosen dates. We’ll cover any damages up to $100 per box."
              />
            </Col>
          </Row>
          <Row
            style={{
              backgroundColor: '#00144D',
              paddingTop: 60,
              paddingBottom: 60,
            }}
          >
            <Col xs={{ size: 12 }} md={{ size: 4, offset: 4 }}>
              <PricingTitle>Pricing</PricingTitle>
            </Col>
            <Col xs={{ size: 12 }} md={{ size: 4, offset: 4 }}>
              <PricingDetail>
                We’ll always offer the lowest prices on campus. Find anything cheaper? We’ll price
                match.
              </PricingDetail>
            </Col>
            <Col
              xs={{ size: 12 }}
              md={{ size: 4, offset: 4 }}
              align="center"
              style={{ marginBottom: '32px' }}
            >
              <PricingCard />
            </Col>
            <Col xs={{ size: 12 }} md={{ size: 6, offset: 3 }}>
              <PricingSaveText>
                Save up to <span>50%</span> on average
              </PricingSaveText>
              <PricingSaveText>compared to other providers.</PricingSaveText>
            </Col>
          </Row>
          <Row
            style={{
              background: '#FFFFFF',
              paddingTop: 60,
              paddingBottom: 60,
              paddingLeft: 45,
              paddingRight: 45,
            }}
          >
            <Col xs={{ size: 12 }} md={{ size: 4, offset: 4 }}>
              <TestimonialTitle>What Students are Saying</TestimonialTitle>
            </Col>
            <Col xs={{ size: 12 }} md={{ size: 4, offset: 4 }}>
              <TestimonialDetail>Don't just take our word for it</TestimonialDetail>
            </Col>
            <Row>
              <Col xs={{ size: 12 }} md={{ size: 4 }} style={{ textAlign: 'center' }}>
                <QuoteItem
                  quoteText={
                    "As an international student, summer storage has always been a big concern. The storage companies I've used have unexpected additional fees and returned my boxes in moldy condition. StoreWithPenn makes sense given the free space upperclassmen off-campus have and is much more trustworthy."
                  }
                  quoteImg={Karim_profile}
                  quoteName="Karim E.S."
                />
              </Col>
              <Col xs={{ size: 12 }} md={{ size: 4 }} style={{ textAlign: 'center' }}>
                <QuoteItem
                  quoteText={
                    "I had a difficult experience with storage last summer and the storage options weren't flexible enough for me to easily store my stuff. StoreWithPenn gives me a cheap and seamless option for storing my items at a place very close to my dorm."
                  }
                  quoteImg={Skim_profile}
                  quoteName="Sophia K."
                />
              </Col>
              <Col xs={{ size: 12 }} md={{ size: 4 }} style={{ textAlign: 'center' }}>
                <QuoteItem
                  quoteText={
                    'Anyone who needs summer storage should use StoreWithPenn. It insures your items over the summer and allows you to save hundreds of dollars on storage while having a trusted host at a close distance to your dorm.'
                  }
                  quoteImg={Alexa_profile}
                  quoteName="Alexa S."
                />
              </Col>
            </Row>
          </Row>

          <Row style={{ paddingLeft: 45, backgroundColor: '#333' }}>
            <footer className="footer" style={{ padding: '20px 0px', backgroundColor: '#333' }}>
              <span style={{ color: '#eee' }}>&#169; 2019 StoreWith. All Rights Reserved.</span>
            </footer>
          </Row>
        </LandingPageContainer>
      </CenteredPageContainer>
    );
  }
}

export default withRouter(LandingPage);



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingPage.tsx